<app-auth-container
	label="Password reset"
	description="Enter your email address associated with your account, and we'll email you a secure link to reset your password."
	submitButtonText="Send link"
	[hideSocials]="true"
	[formGroup]="authForm"
	(onFormSubmit)="resetPassword()"
	[disabled]="(vm$ | async).loading"
	[loading]="(vm$ | async).loading"
>
	<app-input
		form-content
		class="font-light mt-12"
		label="Email"
		[formControlName]="USER_CREDENTIALS.EMAIL"
		[testHook]="testHooks.Email"
	></app-input>

	<ng-container footer-content>
		<p>Don't have an account yet?</p>
		<app-anchor
			type="bold"
			[url]="registerUrl"
			[testHook]="testHooks.CreateAccountLink"
			>Create account</app-anchor
		>
	</ng-container>
</app-auth-container>
